import { useState, useEffect } from 'react';

interface Props {
  onContactClick: () => void;
}

// Erst einblenden, wenn der Hero-CTA sicher aus dem Viewport ist
const SCROLL_THRESHOLD = 400;

const StickyContactButton = ({ onContactClick }: Props) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(window.scrollY > SCROLL_THRESHOLD);
    handler();
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={onContactClick}
      aria-label="Kontakt aufnehmen"
      className="fixed bottom-5 right-5 z-40 flex h-14 w-14 cursor-pointer items-center justify-center rounded-full border-0 bg-ak-accent text-white shadow-[0_8px_24px_rgba(0,0,0,0.45)] transition-[background-color,transform] duration-200 hover:bg-ak-accent-hover active:scale-[0.95] md:hidden"
    >
      <i className="pi pi-envelope text-xl"></i>
    </button>
  );
};

export default StickyContactButton;
